<template>
  <ion-toolbar>
    <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
      <ion-button color="warning" class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button @click="skip" class="pill next-pill-button">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Experience Overview</h1>
          <p class="auth-subtext">Enter your work experience</p>
        </div>
        <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
        </div>
      </div>

      <el-form class="full_page" :model="form" label-width="200px" ref="userForm" label-position="top">
        <el-form-item :error="v$.year_experience_id.$error" :show-message="false" class="no-scroll"
          label="How many years of pharmacy work experience do you have?" prop="year_experience_id">
          <el-select v-model="form.year_experience_id" placeholder="Select" ref="experienceRef"
            @change="validateField('year_experience_id')" @blur="validateField('year_experience_id')">
            <div class="auth-header">
              <div class="auth-heading">
                <h1>Select Experience</h1>
              </div>
            </div>

            <button class="icon-button close-button" @click.prevent="closeOption('experienceRef')">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                  fill="black" />
              </svg>
            </button>

            <el-option v-for="option in getExperiences" :key="option.id" :label="option.yearExperience"
              :value="option.id">
              <template #default>
                <el-radio :model-value="form.year_experience_id" :label="option.id">
                  {{ option.yearExperience }}
                </el-radio>
              </template>
            </el-option>
          </el-select>
          <el-form-item-error v-if="v$.year_experience_id.$error">{{ v$.year_experience_id.$errors[0].$message
            }}</el-form-item-error>
        </el-form-item>

        <!-- Experience with Checkboxes -->
        <el-form-item label="What role(s) are you seeking?" :error="v$.category_level_ids.$error" :show-message="false"
          class="no-scroll">
          <el-select v-model="form.category_level_ids" placeholder="Select" multiple ref="categoryRef"
            @change="validateField('category_level_ids')" @blur="validateField('category_level_ids')">

            <div class="auth-header">
              <div class="auth-heading">
                <h1>Select Role</h1>
              </div>
            </div>

            <button class="icon-button close-button" @click.prevent="closeOption('categoryRef')">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                  fill="black" />
              </svg>
            </button>

            <el-option v-for="option in getSeekerCategories" :key="option.id" :label="option.title" :value="option.id">
              <template #default>
                <el-checkbox :model-value="form.category_level_ids.includes(option.id)" :label="option.id"
                  @change="toggleExperience(option.id)">
                  {{ option.title }}
                </el-checkbox>
              </template>
            </el-option>
            <!-- If "Other" is selected, show the el-input -->
            <div v-if="showOtherInput">
              <el-input v-model="form.category_level_other" placeholder="Please specify"
                @input="validateField('category_level_other')" @blur="validateField('category_level_other')" />
              <el-form-item-error v-if="v$.category_level_other.$error">{{
                v$.category_level_other.$errors[0].$message
              }}</el-form-item-error>
            </div>
            <el-button type="primary" @click.prevent="closeOption('categoryRef')" :disabled="isCategoryDisableDrawer">
              Continue
            </el-button>
          </el-select>
          <el-form-item-error v-if="v$.category_level_ids.$error">{{ v$.category_level_ids.$errors[0].$message
            }}</el-form-item-error>
        </el-form-item>

        <el-button type="primary" :disabled="isSubmitDisabled" @click="submitForm">Continue</el-button>
        <!-- <el-button type="primary" @click="submitForm" >Continue</el-button> -->
      </el-form>
      <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
      </div>
    </div>


    <!-- Select overlay -->
    <div class="bg-overlay"></div>
  </div>

</template>

<script setup>
import { reactive, computed, inject, onMounted, onBeforeMount, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router';
import { useStore } from "vuex";
import { useVuelidate } from '@vuelidate/core';
import { required, helpers, requiredIf } from '@vuelidate/validators';
import SvgIcon from '@/components/Svg/SvgIcon.vue';


const setPageClassGlobal = inject(['setPageClassGlobal']);
const $router = useRouter();
const $store = useStore();
const $route = useRoute()
// let getJobSeekerLevel = ref([]);
let getExperiences = ref([]);
let getSeekerCategories = ref([]);
const profileRef = ref(null);
const experienceRef = ref(null);
const categoryRef = ref(null);
// Form data
const form = reactive({
  year_experience_id: '',
  category_level_ids: [],
  category_level_other: '',
})




// Find the ID of the "Other" option dynamically
const otherCategoryId = computed(() => {
  const otherOption = getSeekerCategories.value.find(
    (option) => option.title === "Other"
  );
  return otherOption ? otherOption.id : null;
});

const showOtherInput = computed(() =>
  form.category_level_ids.includes(otherCategoryId.value)
);

watch(
  () => form.category_level_ids,
  (newVal) => {
    if (newVal.includes(otherCategoryId.value)) {
      validateField('category_level_other');
    }
  }
);

// Watch the input value and update the category_level_ids if necessary
// watch(otherRole, (newVal) => {
//       if (showOtherInput.value) {
//         form.value.category_level_ids = form.value.category_level_ids.filter(id => id !== "yhc45ff4-1037-4d21-a8d5-7aca623e0d2d");
//         if (newVal) {
//           form.value.category_level_ids.push(newVal);
//         }
//       }
//     });


const closeOption = (refInfo) => {
  if (refInfo == 'profileRef') {
    profileRef.value.blur();
  } else if (refInfo == 'experienceRef') {
    experienceRef.value.blur();
  } else if (refInfo == 'categoryRef') {
    categoryRef.value.blur();
  }
}
const validateField = (fieldName) => {
  // Trigger validation for the specified field
  v$.value[fieldName].$touch();
  document.body.classList.remove('overflow-hidden');
};

// Temporary state for checkbox handling
const categoryCheckbox = ref([])


// Sync checkbox state with form state
watch(categoryCheckbox, (newVal) => {
  form.category_level_ids = newVal
}, { deep: true })

const toggleExperience = (id) => {
  const index = form.category_level_ids.indexOf(id);
  if (index === -1) {
    form.category_level_ids.push(id);
  } else {
    form.category_level_ids.splice(index, 1);
  }
}

const rules = computed(() => {
  return {
    // profile_type_id: { required: helpers.withMessage('Please select level option', required) },
    year_experience_id: { required: helpers.withMessage('Please select the work experience that you have.', required) },
    category_level_ids: { required: helpers.withMessage('Please enter the role(s) that you are seeking.', required) },
    category_level_other: {
      requiredIf: requiredIf(() => form.category_level_ids.includes(otherCategoryId.value)),
      // Add custom message for the requiredIf validation
      required: helpers.withMessage(
        'Please enter the category level for "Other"',
        requiredIf(() => form.category_level_ids.includes(otherCategoryId.value))
      ),
    },
   
  };
});

const v$ = useVuelidate(rules, form);

const goBack = async () => {
  const back = await $store.dispatch("getAuthPageBack");
  $router.push({
    name: back,
  });
};

const goNext = () => {
  $router.push({
      name: 'auth_software_experience',
    });

  // $router.push({
  //   name: 'jobseeker_auth_cv',
  // });
};



const isSubmitDisabled = computed(() => {
  // Assuming v$ is used for form validation
  return (
    v$.value.$pending || // If any validation is pending
    v$.value.$errors.length > 0 || // If there are any validation errors
    form.year_experience_id === "" || // Check for empty year_experience_id
    form.category_level_ids.length === 0 || // Check for empty category_level_ids array
    (form.salary_expectation_hourly === "" && form.salary_expectation_annually === "")
  );
});

const isCategoryDisableDrawer = computed(() => {

  return (

    v$.value.category_level_other.$errors.length > 0
  );
});
// const addOveflowHiddentoBody = () => {
//   document.body.classList.add('overflow-hidden');
// };

// Form submission
const submitForm = async () => {

  const result = await v$.value.$validate();
  console.log("🚀 ~ handleSubmit ~ result:", form)
  if (!result) {
    console.log('The form has errors');
    return;
  }
  (async () => {
    try {

      await $store.dispatch("SAVE_USER_DATA", form);
      goNext();
    } catch (error) {
      console.log("error submit!!");
    }
  })();
  // goNext();
}

const skip = () => {
  (async () => {

    try {
      await $store.dispatch("addAuthPageBack", $route.name);
      goNext()
    } catch (error) {
      console.log(error);
    }
  })();

}

onMounted(() => {
  setPageClassGlobal('global_auth_page');
});

onBeforeMount(async () => {
  return new Promise((resolve) => {
    // $store
    //   .dispatch("GET_JOB_SEEKER_LEVEL")
    //   .then((response) => {
    //     let FetchResult = response.data.profileTypes;
    //     console.log("🚀 ~ .then ~ FetchResult:", FetchResult)
    //     getJobSeekerLevel.value = FetchResult;
    //     console.log("🚀 ~ .then ~ jobFetchResult:", getJobSeekerLevel)
    //     resolve(response);
    //   });

    $store
      .dispatch("GET_JOB_SEEKER_EXPERIENCE")
      .then((response) => {
        let FetchExpResult = response.data.experiences;
        console.log("🚀 ~ .then ~ FetchExpResult:", FetchExpResult)
        getExperiences.value = FetchExpResult;
        resolve(response);
      });
    $store
      .dispatch("GET_JOB_SEEKER_CATEGORY")
      .then((response) => {
        let FetchResult = response.data.categories;
        getSeekerCategories.value = FetchResult;
        console.log("🚀 ~ onBeforeMount ~ FetchResultdddd", FetchResult)
        resolve(response);
      });
  });
});
</script>
